export default {
    buttons_allowed: []
}
